// Packages
import Vue from 'vue';

// Components
import ToMarketing from '~scripts/components/vue/to-marketing/ToMarketing.vue';

new Vue({
  name: 'ToMarketing',
  render(h) {
    return h(ToMarketing);
  },
}).$mount(document.querySelector('.js-to-marketing-form'));
